import {bingAds} from '../../../externalTrackers/index.js'
import {getProperties} from './data.js'

const track = bingAds({id: '187056365'})
const eventsMapping = {
  'Detail Viewed': 'page',
  'Lead Triggered': 'event',
  'Ad Inserted': 'event',
  'Ad Insertion IO Date Confirmed': 'event',
  'Landing IO Date Confirmed': 'event'
}
const allowedEvents = Object.keys(eventsMapping)

export default ({event, properties}) => {
  const needsToTrack = allowedEvents.includes(event)

  if (needsToTrack) {
    const mappedEvent = eventsMapping[event]
    const pixelProperties = getProperties({event, properties})

    track({event: mappedEvent, properties: pixelProperties})
  }
}
